// CartContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { getMemberCart, createMemberCart } from '../../services/memberApiServices';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refresh, setRefresh] = useState(false)
    console.log(cart, 'cart');

    const getMemberId = () => {
        return JSON.parse(localStorage.getItem("memberinfo"))?.id || -1
    };

    const getMemberUrl = () => {
        return JSON.parse(localStorage.getItem("memberinfo"))?.imgurl
    }
    const getMemberNumber = () => {
        return JSON.parse(localStorage.getItem("memberinfo"))?.number
    };

    const getMemberName = () => {
        return JSON.parse(localStorage.getItem("memberinfo"))?.username
    };
    const getGymId = () => {
        const userInfo = JSON.parse(localStorage.getItem("memberinfo"))?.gymid
        return userInfo || -1
    };

    const fetchCart = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                return;
            } else {
                const gymId = getGymId();
                const memberId = getMemberId();
                const response = await getMemberCart(gymId, memberId);

                if (!response || response === "false") {
                    setCart(null);
                    return;
                }

                const cartData = await response.json();
                setCart(cartData?.[0] || null);
            }
        } catch (err) {
            console.error("Error fetching cart:", err);
            setError("Failed to load cart");
        } finally {
            setLoading(false);
            setRefresh(false)
        }
    };


    const addToCart = async (item) => {
        try {
            const gymId = getGymId();
            const memberId = getMemberId();
            const newItem = {
                itemid: item._id,
                type: item.type
            };

            let updatedCart;
            if (cart) {
                const existingItemIndex = cart.membershipitems.findIndex(
                    cartItem => cartItem.itemid === item._id
                );

                let updatedItems;
                if (existingItemIndex >= 0) {
                    updatedItems = [...cart.membershipitems];
                    updatedItems[existingItemIndex] = newItem;
                } else {
                    updatedItems = [...cart.membershipitems, newItem];
                }

                updatedCart = {
                    ...cart,
                    membershipitems: updatedItems,
                    _id: cart._id
                };
            } else {
                updatedCart = {
                    gymid: gymId,
                    memberid: memberId,
                    membershipitems: [newItem]
                };
            }

            const savedCart = await createMemberCart(gymId, updatedCart);
            if (!savedCart || savedCart === "false") return;

            const cartData = await savedCart.json();
            setCart(cartData);
        } catch (err) {
            console.error("Error adding to cart:", err);
            setError("Failed to add item to cart");
        }
    };

    // Remove item from cart
    const removeFromCart = async (itemId) => {
        try {
            const gymId = getGymId();
            if (!cart) return;

            const updatedItems = cart.membershipitems.filter(
                cartItem => cartItem.itemid !== itemId
            );

            const updatedCart = {
                ...cart,
                membershipitems: updatedItems,
                _id: cart._id
            };

            const savedCart = await createMemberCart(gymId, updatedCart);
            if (!savedCart || savedCart === "false") return;

            const cartData = await savedCart.json();
            setCart(cartData);
        } catch (err) {
            console.error("Error removing from cart:", err);
            setError("Failed to remove item from cart");
        }
    };

    // Clear entire cart
    const clearCart = async () => {
        try {
            const gymId = getGymId();
            if (!cart) return;

            const updatedCart = {
                ...cart,
                membershipitems: [],
                _id: cart._id
            };

            const savedCart = await createMemberCart(gymId, updatedCart);
            if (!savedCart || savedCart === "false") return;

            setCart(null);
        } catch (err) {
            console.error("Error clearing cart:", err);
            setError("Failed to clear cart");
        }
    };

    // Check if an item is in the cart
    const isItemInCart = (itemId) => {
        if (!cart) return false;
        return cart.membershipitems.some(item => item.itemid === itemId);
    };
    // console.log(cart?.membershipitems, 'cart?.membershipitems');

    // Get cart item count
    const getItemCount = () => {
        return cart?.membershipitems?.length || 0;
    };

    // Initial cart fetch
    useEffect(() => {
        fetchCart();
    }, [refresh]);

    const handleReload = () => {
        setRefresh(true)
    }

    return (
        <CartContext.Provider value={{
            cart,
            loading,
            error,
            fetchCart,
            addToCart,
            removeFromCart,
            clearCart,
            isItemInCart,
            getItemCount,
            getMemberId,
            getGymId,
            getMemberNumber,
            getMemberUrl,
            getMemberName,
            handleReload
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};